module.exports = __webpack_public_path__ + "static/img/l293d-1.d991452.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/l293d-1.svg
// module id = //Qi
// module chunks = 0